var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('iframe',{staticClass:"animated fadeIn",staticStyle:{"height":"6500px","width":"100%"},attrs:{"src":'//ikommportal.userecho.com/knowledge-bases/15-the-knowledge-base?sso_token=' +
            _vm.token}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }